import React from "react";

export default function ConfirmDialog({
  open,
  title = "Confirm",
  message = "",
  onConfirm,
  onCancel,
}) {
  if (!open) return null;

  return (
    <div style={styles.backdrop}>
      <div style={styles.modal}>
        <div style={styles.header}>{title}</div>
        <div style={styles.body}>{message}</div>
        <div style={styles.footer}>
          <button style={styles.yesBtn} onClick={onConfirm}>
            Yes
          </button>
          <button style={styles.cancelBtn} onClick={onCancel}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}

const styles = {
  backdrop: {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,0.25)",
    zIndex: 9999,
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    paddingTop: 80, // this makes it appear from top like MVC
  },
  modal: {
    width: 520,
    background: "#fff",
    borderRadius: 4,
    boxShadow: "0 4px 16px rgba(0,0,0,0.35)",
    overflow: "hidden",
    fontFamily: "Arial, sans-serif",
  },
  header: {
    background: "#1b1464", // dark blue like MVC
    color: "#fff",
    fontWeight: 600,
    padding: "10px 14px",
    fontSize: 15,
  },
  body: {
    padding: "14px",
    fontSize: 14,
    color: "#333",
    borderBottom: "1px solid #e5e5e5",
  },
  footer: {
    padding: "10px 14px",
    display: "flex",
    justifyContent: "flex-end",
    gap: 6,
  },
  yesBtn: {
    background: "#fff",
    color: "#333",
    border: "1px solid #c5c5c5",
    padding: "4px 12px",
    cursor: "pointer",
    borderRadius: 2,
  },
  cancelBtn: {
    background: "#fff",
    color: "#333",
    border: "1px solid #c5c5c5",
    padding: "4px 12px",
    cursor: "pointer",
    borderRadius: 2,
  },
};
